import { toHslaString } from 'shared/mappers'
import numeral from 'numeral'

export const getVisualMap = (fillColor: ColorHsla, defaultColor: ColorHsla, heatMap: boolean, breakpoints: Breakpoints[], breakpointMap: boolean, gradientScale: number, gradientMapSourceType: string, enableBreakpointLegend: boolean, legendColor: ColorHsla) =>
    breakpointMap ? getBreakpointMap(breakpoints, gradientMapSourceType, enableBreakpointLegend, legendColor) : getGradientMap(fillColor, defaultColor, heatMap, gradientScale)

export const getBreakpointMap = (breakpoints: Breakpoints[], gradientMapSourceType: string, enableBreakpointLegend: boolean, legendColor: ColorHsla) => [
{
    type: 'piecewise',
    show: enableBreakpointLegend,
    min: 0,    
    pieces: getPieces(breakpoints),
    align: 'left',
    left: 'auto',
    right: 0,
    top:"300",
    textStyle: {
        color: toHslaString(legendColor),
    },
    formatter: (value: any, value2: any) =>
        gradientMapSourceType === 'Dollars'
            ? `${imod.cms.scoreboards.verbiage.globalCurrencySymbol}${numeral(value).format()} - ${imod.cms.scoreboards.verbiage.globalCurrencySymbol}${numeral(value2).format()}`
            : `${numeral(value).format()} - ${numeral(value2).format()}`,
}
]

export const getPieces = (breakpoints: Breakpoints[]) => {
    const pieces: any[] = []    
    for (const points of breakpoints) {
        const breakpointColor = toHslaString(points.color)
        pieces.push({ min: points.min, max: points.max, color: breakpointColor! })
    }
    return pieces
}

export const getGradientMap = (fillColor: ColorHsla, defaultColor: ColorHsla, heatMap: boolean, gradientScale: number) => [
{
    type: 'continuous',
    show: false,
    min: 0,
    max: heatMap ? gradientScale : 1,
    color: [toHslaString(fillColor), toHslaString(defaultColor)],
}
]

export const getScaleData = (data: ViewMapDataRecord[], gradientMapSourceType: string, gradientMapEnabled: boolean, gradientScale: number) => {
    const maxValue = getMaxValue(gradientMapSourceType, data)
    return gradientMapEnabled ? (gradientMapSourceType === 'Dollars'
        ? data.map(record => ({ ...record, value: Math.ceil((record.value * gradientScale) / maxValue), donorsTooltipValue: record.donors, dollarsTooltipValue: record.value }))
        : data.map(record => ({ ...record, value: Math.ceil((record.donors * gradientScale) / maxValue), donorsTooltipValue: record.donors, dollarsTooltipValue: record.value }))
    ) : ((gradientMapSourceType === 'Dollars'
        ? data.map(record => ({ ...record, value: record.value, donorsTooltipValue: record.donors, dollarsTooltipValue: record.value }))
        : data.map(record => ({ ...record, value: record.donors, donorsTooltipValue: record.donors, dollarsTooltipValue: record.value }))
    ))
}

export const getMaxValue = (gradientMapSourceType: string, data: ViewMapDataRecord[]) => gradientMapSourceType === 'Dollars' ? Math.max(...data.map(x => x.value)) : Math.max(...data.map(x => x.donors))
